var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.12502 19.25C5.13752 19.25 5.95835 18.4292 5.95835 17.4167C5.95835 16.4042 5.13752 15.5834 4.12502 15.5834C3.1125 15.5834 2.29169 16.4042 2.29169 17.4167C2.29169 18.4292 3.1125 19.25 4.12502 19.25Z",
    stroke: "#787486",
    strokeWidth: 1.375,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.12502 6.41667C5.13752 6.41667 5.95835 5.59588 5.95835 4.58333C5.95835 3.57081 5.13752 2.75 4.12502 2.75C3.1125 2.75 2.29169 3.57081 2.29169 4.58333C2.29169 5.59588 3.1125 6.41667 4.12502 6.41667Z",
    stroke: "#787486",
    strokeWidth: 1.375,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.12502 12.8333C5.13752 12.8333 5.95835 12.0125 5.95835 11C5.95835 9.98741 5.13752 9.16663 4.12502 9.16663C3.1125 9.16663 2.29169 9.98741 2.29169 11C2.29169 12.0125 3.1125 12.8333 4.12502 12.8333Z",
    stroke: "#787486",
    strokeWidth: 1.375,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.625 11H19.7083",
    stroke: "#787486",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.625 17.4166H19.7083",
    stroke: "#787486",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.625 4.58337H19.7083",
    stroke: "#787486",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListTwo);
export default __webpack_public_path__ + "static/media/List-two.040182c90706f7f5cad6219ccd032641.svg";
export { ForwardRef as ReactComponent };